import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { PressStrip } from "@/components/PressStrip";
import { About } from "@/components/About";
import { Contribute } from "@/components/Contribute";
import { EditorialBreak } from "@/components/EditorialBreak";
import { Network } from "@/components/Network";
import { Contact } from "@/components/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="bg-background text-foreground" data-testid="site-root">
        <Header />
        <main>
          <Hero />
          <Manifesto />
          <EditorialMarquee />
          <PressStrip />
          <Contribute />
          <EditorialBreak
            fullBleed
            testId="editorial-break-grand-palais"
            src="/media/grand-palais.webp"
            credit="capGrandPalais"
            altKey="altGrandPalais"
          />
          <Network />
          <About />
          <EditorialBreak
            testId="editorial-break-visitor"
            src="/media/opening-night.webp"
            credit="capOpening"
            altKey="altOpening"
          />
        </main>
        <Contact />
        <Toaster position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
